import React, { lazy, Suspense } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import { Spin } from "antd";

const Index = lazy(() => import("@/pages/index"));
const Recast = lazy(() => import("@/pages/competition/recast"));
const Mix = lazy(() => import("@/pages/competition/mix"));
const Virtual = lazy(() => import("@/pages/competition/virtual"));
const Product = lazy(() => import("@/pages/product"));
const Game = lazy(() => import("@/pages/game"));
const Home = lazy(() => import("@/pages/home"));
const Login = lazy(() => import("@/pages/login"));
const Participate = lazy(() => import("@/pages/participate"));
const Work = lazy(() => import("@/pages/work"));
const WorkAdd = lazy(() => import("@/pages/work-add"));
const WorkDetail = lazy(() => import("@/pages/work-detail"));
const Top = lazy(() => import("@/pages/top"));
//Do not edit! CDA PREPEND:import
const Page404 = lazy(() => import("@/pages/400/page404"));

const routerList = [
  // createRedirect('/', '/page1'),
  {
    path: "/",
    element: createSuspense(<Index />)
  },
  createRedirect("/competition", "/competition/recast"),
  {
    path: "/competition/recast",
    element: createSuspense(<Recast />)
  },
  {
    path: "/competition/mix",
    element: createSuspense(<Mix />)
  },
  {
    path: "/competition/virtual",
    element: createSuspense(<Virtual />)
  },
  {
    path: "/product",
    element: createSuspense(<Product />)
  },
  // {
  //   path: "/product/:id",
  //   element: createSuspense(<ProductDetail />)
  // },
  {
    path: "/game",
    element: createSuspense(<Game />)
  },
  {
    path: "/home",
    element: createSuspense(<Home />)
  },
  {
    path: "/login",
    element: createSuspense(<Login />)
  },
  {
    path: "/participate",
    element: createSuspense(<Participate />)
  },
  {
    path: "/work",
    element: createSuspense(<Work />)
  },
  {
    path: "/work-add",
    element: createSuspense(<WorkAdd />)
  },
  {
    path: "/work-detail",
    element: createSuspense(<WorkDetail />)
  },
  {
    path: "/work-detail/:id",
    element: createSuspense(<WorkDetail />)
  },
  {
    path: "/top/:type",
    element: createSuspense(<Top />)
  },
  //Do not edit! CDA PREPEND:router
  {
    path: "*",
    element: createSuspense(<Page404 />)
  }
];

function SuspenseElement({ children }) {
  return (
    <Suspense
      fallback={
        <div
          style={{ height: "300px", lineHeight: "300px", textAlign: "center" }}
        >
          <Spin size="large"></Spin>
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

function createSuspense(children) {
  return <SuspenseElement>{children}</SuspenseElement>;
}

function createRedirect(path, to, replace = true) {
  return {
    path,
    element: <Navigate replace={replace} to={to} />
  };
}

const Router = () => useRoutes(routerList);

export default Router;
